// src/api/meetingApi.jsx
import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchMeetings = async (userId) => {
  const config = {
    ...getAuthHeader(),
    params: {},
  };
  if (userId != null) config.params.user_id = userId;

  const res = await apiClient.get(`/meetings/get_all`, config);
  return res.data?.data || [];
};
export const createMeeting = async ({ subject, meeting_date_time, link, user_ids }) => {
  const payload = {
    subject,
    meeting_date_time,
    link: link ?? null,
    user_ids: Array.isArray(user_ids) ? user_ids.join(",") : user_ids,
  };

  const res = await apiClient.post(`/meetings/create`, payload, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "application/json",
    },
  });
  return res.data; 
};
